/** La phrase d'un canal personnel que l'organisation a eteint (G16). */
export const RAISON_CANAL_ETEINT = 'Canal éteint par l’organisation.';

/**
 * L'ETAT D'UN INTERRUPTEUR PERSONNEL de canal (essai final, ecart 8). Quand
 * l'organisation a eteint le canal, l'interrupteur personnel est dessine
 * ETEINT, verrouille, avec sa raison : il ne montre jamais un « allume » qui
 * ne recevra rien, et seul l'interrupteur de l'org (section « Canaux ») decide.
 * Exporte pour le test.
 */
export function etatInterrupteurPersonnel(
  actifPourLOrg: boolean,
  preference: boolean | undefined,
  pret: boolean,
): { checked: boolean; locked: boolean; lockedReason?: string; hint?: string; badge?: string } {
  if (!actifPourLOrg) {
    return { checked: false, locked: true, lockedReason: RAISON_CANAL_ETEINT, hint: RAISON_CANAL_ETEINT, badge: 'éteint' };
  }
  return { checked: preference !== false, locked: !pret };
}
